{
	"tabs": {
		"label": "Arrival and departure sections",
		"overview": "Overview",
		"journeys": "Journeys",
		"entryPoints": "Entry points",
		"notReadyBadge_one": "{{n}} arrival journey today or tomorrow is not ready",
		"notReadyBadge_other": "{{n}} arrival journeys today or tomorrow are not ready"
	},
	"common": {
		"tryAgain": "Try again"
	},
	"tiles": {
		"label": "Travel on {{day}}",
		"loadFailed": "Couldn't load the travel summary",
		"arrivingToday": "Arriving today",
		"arrivingOn": "Arriving {{day}}",
		"departingToday": "Departing today",
		"departingOn": "Departing {{day}}",
		"noneOnDay": "None on this day",
		"arrivingNote_one": "{{n}} journey · {{landed}} landed",
		"arrivingNote_other": "{{n}} journeys · {{landed}} landed",
		"departingNote_one": "{{n}} journey · {{departed}} left",
		"departingNote_other": "{{n}} journeys · {{departed}} left",
		"notReady": "Not ready",
		"notReadyNote_one": "{{n}} journey",
		"notReadyNote_other": "{{n}} journeys",
		"notReadyNoteToday_one": "{{n}} journey today or tomorrow",
		"notReadyNoteToday_other": "{{n}} journeys today or tomorrow",
		"notReadyNoteDay_one": "{{n}} journey on {{day}} or {{next}}",
		"notReadyNoteDay_other": "{{n}} journeys on {{day}} or {{next}}",
		"allReady": "Everyone arriving is ready",
		"delayedToday": "Delayed today",
		"delayed": "Delayed",
		"delayedNote": "View journeys",
		"delayedNoteToday": "View today and tomorrow",
		"delayedNoteDay": "View {{day}} and {{next}}",
		"allOnTime": "All on time",
		"noArrival": "No arrival yet",
		"everyoneHasArrival": "Everyone has an arrival",
		"viewRecords": "View records",
		"contingents_one": "{{n}} contingent",
		"contingents_other": "{{n}} contingents"
	},
	"dayBadge": {
		"arrivals_one": "{{n}} arrival",
		"arrivals_other": "{{n}} arrivals",
		"departures_one": "{{n}} departure",
		"departures_other": "{{n}} departures",
		"people_one": "{{n}} person",
		"people_other": "{{n}} people",
		"title": "{{arrivals}} · {{departures}} ({{people}})"
	},
	"board": {
		"title": "Day board",
		"counts_one": "<b>{{in}}</b> in · <b>{{out}}</b> out · <b>{{n}}</b> journey",
		"counts_other": "<b>{{in}}</b> in · <b>{{out}}</b> out · <b>{{n}}</b> journeys",
		"viewLabel": "Day board view",
		"byJourney": "By journey",
		"timeline": "Timeline",
		"list": "List",
		"loadFailed": "Couldn't load this day's journeys",
		"emptyTitle": "No travel on {{day}}",
		"emptyHint": "Pick another day.",
		"emptyHintAdd": "Pick another day, or add an arrival or a departure.",
		"loading": "Loading…",
		"showMore": "Show more",
		"showLess": "Show less",
		"showAll_one": "Show all {{n}} journey",
		"showAll_other": "Show all {{n}} journeys",
		"showAllRows_one": "Show all {{n}} row",
		"showAllRows_other": "Show all {{n}} rows",
		"keyNotReady": "Not ready: card not approved, no driver yet, or no bed",
		"now": "Now, {{time}}",
		"arrival": "Arrival",
		"departure": "Departure",
		"journeyName": "{{name}} · {{place}}",
		"partNotReady_one": "{{n}} person not ready",
		"partNotReady_other": "{{n}} people not ready",
		"busiest": {
			"title": "Busiest hour per entry point",
			"peak": "<b>{{n}}</b><small> at {{time}}</small>",
			"peakOf": "<b>{{n}}</b><small>/{{cap}} at {{time}}</small>",
			"tip_one": "{{name}}, busiest hour {{from}}–{{to}}: {{n}} person.",
			"tip_other": "{{name}}, busiest hour {{from}}–{{to}}: {{n}} people.",
			"tipCapacity_one": "{{name}}, busiest hour {{from}}–{{to}}: {{n}} person. The welcome desk processes {{cap}} an hour.",
			"tipCapacity_other": "{{name}}, busiest hour {{from}}–{{to}}: {{n}} people. The welcome desk processes {{cap}} an hour."
		}
	},
	"attention": {
		"title": "Needs attention",
		"loadFailed": "Couldn't load what needs attention.",
		"windowToday": "Arrivals today and tomorrow",
		"windowDay": "Arrivals {{day}} and {{next}}",
		"clear": "All clear",
		"clearHint": "Nothing needs you right now.",
		"view": "View",
		"not_approved": {
			"title_one": "{{n}} person arriving has a card not approved yet",
			"title_other": "{{n}} people arriving have cards not approved yet",
			"hint": "Transport and rooms wait for approval."
		},
		"not_ready": {
			"title_one": "{{n}} person arriving is not ready",
			"title_other": "{{n}} people arriving are not ready",
			"hint_one": "On {{n}} journey. Card not approved, no driver yet, or no bed.",
			"hint_other": "On {{n}} journeys. Card not approved, no driver yet, or no bed.",
			"transfers": "Transfers this day",
			"rooms": "Rooms this day"
		},
		"cancelled": {
			"title_one": "{{n}} person is on a cancelled or diverted flight",
			"title_other": "{{n}} people are on cancelled or diverted flights",
			"hint_one": "{{n}} flight. Rebook them, then check their transfer.",
			"hint_other": "{{n}} flights. Rebook them, then check their transfers."
		},
		"over_capacity": {
			"title_one": "{{n}} entry point is over capacity",
			"title_other": "{{n}} entry points are over capacity",
			"hint": "On {{day}}. Add desk staff or ask contingents to move flights.",
			"hintNamed": "{{names}} on {{day}}. Add desk staff or ask contingents to move flights."
		},
		"at_risk": {
			"title_one": "{{n}} person's connection is at risk",
			"title_other": "{{n}} people's connections are at risk",
			"hint_one": "Less than {{count}} minute to change, or a connecting flight cancelled.",
			"hint_other": "Less than {{count}} minutes to change, or a connecting flight cancelled."
		},
		"manual": {
			"title_one": "{{n}} flight is set by hand",
			"title_other": "{{n}} flights are set by hand",
			"hint": "Tracking is paused, so their times won't update by themselves."
		},
		"no_arrival": {
			"title_one": "{{n}} person has no arrival yet",
			"title_other": "{{n}} people have no arrival yet",
			"hint_one": "{{n}} contingent still to add them. Chase them before the window closes.",
			"hint_other": "{{n}} contingents still to add them. Chase them before the window closes.",
			"hintNoc": "Their cards are approved. Add their arrival so transport and rooms can plan."
		}
	},
	"contingent": {
		"title": "By contingent",
		"note": "Most people missing an arrival first",
		"legend": "Arrival coverage key",
		"segment": {
			"arrived": "Arrived",
			"booked": "Booked, still to come",
			"not_approved": "Card not approved yet",
			"no_arrival": "No arrival"
		},
		"segmentCount": "{{label}}: {{n}}",
		"loadFailed": "Couldn't load the contingents",
		"emptyTitle": "No approved or pending cards yet",
		"emptyHint": "Contingents show here once their people are registered.",
		"cardLine_one": "{{arrived}} of {{n}} arrived · {{notApproved}} not approved",
		"cardLine_other": "{{arrived}} of {{n}} arrived · {{notApproved}} not approved",
		"noArrivalPill_one": "{{n}} no arrival",
		"noArrivalPill_other": "{{n}} no arrival",
		"percent": "({{n}}%)",
		"col": {
			"contingent": "Contingent",
			"people": "People",
			"coverage": "Arrival coverage",
			"arrived": "Arrived",
			"noArrival": "No arrival",
			"notApproved": "Not approved",
			"travel": "Travel"
		}
	},
	"guide": {
		"title": "Arrival and departure statuses",
		"ready": "Readiness",
		"readyNote": "For arrivals still to come: what has to be in place before people land.",
		"notReady": "Not ready",
		"notReadyHint": "Someone's card is not approved, their transfer has no driver yet, or they have no bed.",
		"card": "Cards approved",
		"cardHint": "Approved cards of everyone on it. Transport and rooms act on approved cards only.",
		"transfer": "Transfer",
		"transferHint": "The airport transfer of those who need one: none yet, waiting for a driver, assigned, on the road or done.",
		"beds": "Beds",
		"bedsHint": "People with a bed to go to.",
		"checkedOut": "Checked out",
		"checkedOutHint": "For departures: people who have checked out of their room.",
		"flights": "Flight status",
		"flightsNote": "From flight tracking, or set by hand. Coaches and ferries are Scheduled or Delayed."
	},
	"desk": {
		"today": "Sector 3 today",
		"direction": "Arrivals or departures",
		"arrivals": "Arrivals",
		"departures": "Departures",
		"intro": "Everyone travelling on the day, with their transfer and room. Times in {{zone}}.",
		"search": "Name or card number",
		"allNocs": "All NOCs",
		"noc": "NOC",
		"tabs": "Who still needs something",
		"view": {
			"all": "Everyone",
			"no_transfer": "No transfer yet",
			"no_room": "No room yet",
			"not_approved": "Card not approved"
		},
		"selection": "Selected people",
		"selected_one": "{{n}} person selected",
		"selected_other": "{{n}} people selected",
		"clear": "Clear",
		"arrangeFor_one": "Arrange transfer for {{n}} person",
		"arrangeFor_other": "Arrange transfer for {{n}} people",
		"selectAll": "Select everyone shown who has no transfer",
		"selectPerson": "Select {{name}}",
		"col": {
			"person": "Person",
			"arriving": "Arriving ({{zone}})",
			"leaving": "Leaving ({{zone}})",
			"arrivingShort": "Arriving",
			"leavingShort": "Leaving",
			"card": "Card",
			"transfer": "Transfer",
			"room": "Room"
		},
		"loadFailed": "Couldn't load the people for this day.",
		"empty": {
			"arrivals": "No arrivals on {{day}}",
			"departures": "No departures on {{day}}",
			"view": "Nobody on {{day}} is waiting for this",
			"hint": "Pick another day, or add an arrival.",
			"viewHint": "Everyone travelling that day has it already."
		},
		"showMore": "Show more",
		"wheelchair": "Wheelchair",
		"late": "Later than scheduled",
		"noTime": "Time not known",
		"from": "from {{place}}",
		"to": "to {{place}}",
		"approved": "Approved",
		"transfer": {
			"requested": "Requested, not arranged",
			"notRequested": "Not requested",
			"recheck": "Driver to re-check"
		},
		"arrange": "Arrange transfer",
		"noRoom": "No room",
		"assignRoom": "Assign room",
		"checkedIn": "Checked in",
		"why": {
			"hasTransfer": "Already on a transfer",
			"notApproved": "Approve the card first"
		},
		"nudge": {
			"noTransfer_one": "{{n}} person arriving on {{day}} has no transfer yet.",
			"noTransfer_other": "{{n}} people arriving on {{day}} have no transfer yet.",
			"noTransferHint": "Including anyone who did not ask for one.",
			"noRoom_one": "{{n}} person arriving on {{day}} has no room yet.",
			"noRoom_other": "{{n}} people arriving on {{day}} have no room yet.",
			"noRoomHint": "See them with their travel and transfer on the desk.",
			"open": "Open Logistics Desk"
		},
		"openDesk": "Logistics Desk",
		"tile": {
			"everyone": "travelling on this day",
			"no_transfer": "{{done}} of {{total}} on a transfer",
			"no_room": "{{done}} of {{total}} have a room",
			"not_approved": "{{done}} of {{total}} approved",
			"allDone": "Everyone done"
		},
		"calendar": {
			"titleArrivals": "Arrivals still to arrange",
			"titleDepartures": "Departures still to arrange",
			"upcoming": "Coming up",
			"none": "Nothing left to arrange",
			"transfer_one": "{{n}} person needs a transfer",
			"transfer_other": "{{n}} people need a transfer",
			"room_one": "{{n}} person needs a room",
			"room_other": "{{n}} people need a room"
		}
	}
}
